import { handleActions, combineActions } from 'redux-actions'
import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export default handleActions({
  [combineActions(
    actions.fetchGeolocation,
    actions.fetchGeolocationPending,
    actions.fetchGeolocationSuccess,
    actions.fetchGeolocationFailure,
  )]: (state, action) => state.set('status', action.type),

  [actions.fetchGeolocationSuccess]: (state, action) => state.set('data', fromJS(action.payload)),
}, Map())



// WEBPACK FOOTER //
// ./src/scripts/app/modules/geolocation/reducer.js